import React from 'react';
import { Modal } from '@ver-uds/react';
import { Alert, Button, ButtonGroup } from '@ver-uds/uswds-react';
import AlertConstants from '../../constants/AlertConstants';

export type EnrollmentExitModalProps = {
  when: boolean;
  onOK: () => void;
  onCancel: () => void;
};

const EnrollmentExitModal = ({ when, onOK, onCancel }: EnrollmentExitModalProps): JSX.Element => {
  return (
    <Modal
      id="enrollment-exit-modal"
      header="Warning: Progress Will Be Lost"
      open={when}
      close={onCancel}
      hasDismissButton={false}
    >
      <Modal.Content>
        <Alert status="warning">
          <Alert.Text>{AlertConstants.CONFIRM_LEAVE_ENROLLMENT}</Alert.Text>
        </Alert>
      </Modal.Content>
      <Modal.Footer>
        <ButtonGroup>
          <Button type="button" variant="secondary" onClick={onOK}>
            OK
          </Button>
          <Button type="button" variant="primary" onClick={onCancel}>
            Cancel
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default EnrollmentExitModal;
